import "./style.scss";

import SyncAltIcon from "@mui/icons-material/SyncAlt";
import Google from "assets/img/svg/googleIcon";
import UploadSuccess from "assets/img/svg/uploadSuccess";
import { useTranslation } from "react-i18next";

import BexioIcon from "../../../assets/img/svg/BexioIcon";
import type { TIntegrationName } from "../../../components/IntegrationsSettings/types";

const IntegrationIcon = ({ integration }: { integration: TIntegrationName }) => {
    switch (integration) {
        case "google":
            return <Google className="integration-logo" />;
        case "bexio":
            return <BexioIcon className="integration-logo" />;
        default:
            return <Google className="google" />;
    }
};

const SucceededContent = ({ integration }: { integration?: TIntegrationName }) => {
    const [t] = useTranslation();

    return (
        <div className="integration-connect-popup">
            <div className="integration-connect-popup-head">
                <IntegrationIcon integration={integration ?? "google"} />
                <SyncAltIcon style={{ opacity: 0.4 }} />
                <div className="my-workspace-crealo">
                    <img src="/logoCrealo.png" className="crealo" />
                    {t("IntegrationsSettings.MyCrealoSpace")}
                </div>
            </div>
            <div className="integration-connect-popup-body">
                <UploadSuccess />
                <h1>{t("IntegrationsSettings.ConnectionSucceeded")}</h1>
            </div>
        </div>
    );
};

export default SucceededContent;
